import * as angular from 'angular';
import 'angular-ui-router';
import './ListApplication.scss';
import { ListApplicationController } from './ListApplicationController';
import { ListApplicationControllerNew } from './ListApplicationController_New';
import ListApplicationView from './ListApplicationView.html';
import ListApplicationViewNew from './ListApplicationView_New.html';
import SubheaderListView from '../../navbar/subheader/SubheaderListView.html';
import SubheaderMoveView from '../../navbar/subheader/moveApplication/SubheaderMoveApplicationView.html';
import HistoricMovedApplicationView from './moveApplicationToTenant/historicMovedApplication/historicMovedApplicationView.html';
import MoveApplicationToTenantView from './moveApplicationToTenant/MoveApplicationToTenantView_New.html';
import { SubheaderListController } from 'modules/navbar/subheader/SubheaderListController';
import { UnauthorizedEvent } from 'modules/login/AuthenticationInterceptor';
import { AccountFeatures } from 'modules/account/AccountFeatures';
import { logoutStateName } from 'modules/login';
import { MoveApplicationToTenantComponent } from './moveApplicationToTenant/MoveApplicationToTenant.component';
import { MoveApplicationToTenantComponentNew } from './moveApplicationToTenant/MoveApplicationToTenantNew.component';
import { HeaderCounterApplicationComponent } from './moveApplicationToTenant/headerCounterApplication/headerCounterApplication.component';
import { ActionCardComponent } from './components/actionCard/actionCard.component';
import { BlipSmartComponent } from './components/blipSmart/blipSmart.component';
import { ListApplicationFeatures } from './ListApplicationFeatures';
import { HistoricMovedApplicationComponent } from './moveApplicationToTenant/historicMovedApplication/historicMovedApplication.component';
import { SubheaderMoveApplicationController } from 'modules/navbar/subheader/moveApplication/SubheaderMoveApplicationController';
import { HistoricMovedApplicationController } from './moveApplicationToTenant/historicMovedApplication/historicMovedApplicationController';
import { MoveApplicationToTenantController } from './moveApplicationToTenant/MoveApplicationToTenantController';
import { SimpleActionCardComponent } from './components/simpleActionCard/simpleActionCard.component';
import { studioTrialBannerModule } from '../detail/portal-submodule-builder/templates/builder/studio/components/StudioBanner';
import { studioComponents } from '../detail/portal-submodule-builder/templates/builder/studio/components';
export const applicationListStateName = 'auth.application.list';
export default angular
    .module('application.list', ['ui.router', studioTrialBannerModule, studioComponents])
    .controller('ListApplicationController', ListApplicationController)
    .controller('ListApplicationControllerNew', ListApplicationControllerNew)
    .component('moveApplicationToTenant', MoveApplicationToTenantComponent)
    .component('moveApplicationToTenantNew', MoveApplicationToTenantComponentNew)
    .component('headerCounterApplication', HeaderCounterApplicationComponent)
    .component('historicMovedApplication', HistoricMovedApplicationComponent)
    .component('actionCard', ActionCardComponent)
    .component('simpleActionCard', SimpleActionCardComponent)
    .component('blipSmart', BlipSmartComponent)
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state(applicationListStateName, {
            url: '/application?tenant-invitation&tenantName',
            params: {
                forbidden: undefined,
                shortName: undefined,
                isMovingChatbots: undefined,
            },
            resolve: {
                isContractAdminCanMigrateBots: ['InitializeUserService', async function (InitializeUserService) {
                        await InitializeUserService.initFeatureToggle();
                        return await ListApplicationFeatures.contractAdminCanMigrateBots();
                    }],
            },
            views: {
                'subheader@auth': {
                    template: SubheaderListView,
                    controller: SubheaderListController,
                    controllerAs: '$ctrl',
                },
                '@auth.application': {
                    templateProvider: ['isContractAdminCanMigrateBots', function (isContractAdminCanMigrateBots) {
                            return isContractAdminCanMigrateBots ? ListApplicationViewNew : ListApplicationView;
                        }],
                    controllerProvider: ['isContractAdminCanMigrateBots', function (isContractAdminCanMigrateBots) {
                            return isContractAdminCanMigrateBots ? ListApplicationControllerNew : ListApplicationController;
                        }],
                    controllerAs: '$ctrl',
                },
            },
        })
            .state('auth.application.historic', {
            url: '/application/historic',
            views: {
                'subheader@auth': {
                    template: SubheaderMoveView,
                    controller: SubheaderMoveApplicationController,
                    controllerAs: '$ctrl',
                },
                '@auth.application': {
                    template: HistoricMovedApplicationView,
                    controller: HistoricMovedApplicationController,
                    controllerAs: '$ctrl',
                },
            },
        })
            .state('auth.application.move', {
            url: '/application/move',
            views: {
                'subheader@auth': {
                    template: SubheaderMoveView,
                    controller: SubheaderMoveApplicationController,
                    controllerAs: '$ctrl',
                },
                '@auth.application': {
                    template: MoveApplicationToTenantView,
                    controller: MoveApplicationToTenantController,
                    controllerAs: '$ctrl',
                },
            },
        });
    }])
    .run(['$rootScope', '$state', 'ngToast', '$translate', 'LoadingService', 'OidcService', 'AuthenticationService', '$cookies', 'BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE', function ($rootScope, $state, ngToast, $translate, LoadingService, OidcService, AuthenticationService, $cookies, BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE) {
        $rootScope.$on(UnauthorizedEvent, async () => {
            if (BLIP_ACCOUNT_TOGGLE_DEFAULT_VALUE) {
                $state.go(logoutStateName);
            }
            if ($state.includes('auth')) {
                const errorMsg67 = $translate.instant('utils.errorMsg.67');
                ngToast.warning(errorMsg67);
                LoadingService.stopLoading();
                const isBlipAccountEnabled = await AccountFeatures.isBlipAccountEnabled();
                // FEATURE_TOGGLE
                if (!isBlipAccountEnabled || (AuthenticationService.auth && AuthenticationService.auth.tokenType !== 'Bearer')) {
                    $state.go(logoutStateName);
                }
                else {
                    const currentDomain = `${window.location.origin}/`; // Needs to be dynamic due to custom workspaces domains
                    OidcService.UserManager.signinRedirect();
                }
            }
        });
    }]).name;
